import { render } from "./LabelRectangle.vue?vue&type=template&id=3b5a25d7&scoped=true"
import script from "./LabelRectangle.vue?vue&type=script&lang=js"
export * from "./LabelRectangle.vue?vue&type=script&lang=js"

import "./LabelRectangle.vue?vue&type=style&index=0&id=3b5a25d7&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5a25d7"]])

export default __exports__